import React, { useEffect, useContext } from "react";
import axios from "axios";
// config
import configData from "../../config/config.json";

const CheckComplete = (props) => {
  useEffect(() => {
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else {
      axios
        .get(configData.API_DOMAIN + "/api/v1/Businesses", {
          headers: {
            ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
            LangId: 1,
            Authorization: "Bearer " + getCookie("token"),
          },
        })
        .then((response) => {
          if (response.data.isSuccess) {
            let data = response.data.data;

            const completeList = data.filter((element) => element.isComplete);
            setCookie("OwnerBizNumber", completeList.length, 1);

            if (data.length > 0) {
              if (data.find((element) => element.isComplete)) {
                let businsess = data.find((element) => element.isComplete);

                setCookie("OwnerId", businsess.boId, 1);
                setCookie("BizId", businsess.bId, 1);
                setCookie("BizUuid", businsess.id, 1);

                props.history.push({
                  pathname: "/business-dashboard",
                });
              } else {
                let businsess = data[0];

                setCookie("OwnerId", businsess.boId, 1);
                setCookie("BizId", businsess.bId, 1);
                let uuid =
                  businsess.id && businsess.id !== ""
                    ? businsess.id
                    : "00000000-0000-0000-0000-000000000000";
                setCookie("BizUuid", uuid, 1);

                props.history.push({
                  pathname: "/register-business-step1",
                });
              }
            } else {
              let uuid = "00000000-0000-0000-0000-000000000000";
              setCookie("BizUuid", uuid, 1);

              props.history.push({
                pathname: "/",
              });
            }
          }
        })
        .catch((error) => {
          // alert(error);
        });
      // aidin
      // axios
      //   .get(domain + "/api/biz/register/check-complete", {
      //     headers: {
      //       ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
      //       LangId: 1,
      //       OwnerId: OwnerIdCookie,
      //       BizId: getCookie("BizId"),
      //     },
      //   })
      //   .then((response) => {
      //     if (response.data.msg == "not-registered") {
      //       props.history.push({
      //         pathname: "/signup",
      //       });
      //     } else if (response.data.msg == "done") {
      //       if (response.data.IsComplete) {
      //         props.history.push({
      //           pathname: "/business-dashboard",
      //         });
      //       } else {
      //         props.history.push({
      //           pathname: "/register-business-step1",
      //         });
      //       }
      //     }
      //   });
    }
  }, []);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  //   setCookie
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    document.cookie =
      cname +
      "=" +
      cvalue +
      ";" +
      expires +
      // " domain=en-biz.gishniz.app; path=/";
      " domain=en-biz.gishniz.com; path=/";
  }

  return <></>;
};

export default CheckComplete;
